// extracted by mini-css-extract-plugin
export default {"wrapper":"_dcf074be","mainSeparator":"_49e8a01b","isMobile":"_d130d157","separator":"_cd31490","step":"_6923ebff","label":"_9c781c4b","content":"_231aeca4","action":"_ece34773"};